// extracted by mini-css-extract-plugin
module.exports = {"verifyUser":"VerifyUser_verifyUser__FDqjz","content":"VerifyUser_content__2BpV_","header":"VerifyUser_header__3A6ih","subHeader":"VerifyUser_subHeader__1nYXV"};